import * as React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { injectGlobal, ThemeProvider } from './theme';
import defaultTheme from './theme/default';
import StyleBase from './components/StyleBase';
import Meta from './components/Meta';

// tslint:disable-next-line
injectGlobal`
  * {
    margin: 0; padding: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: border-box;
  }

  @font-face {
    font-family: 'boogie school';
    src: url('/fonts/BoogieSchool-Sans.woff2') format('woff2'),
    url('/fonts/BoogieSchool-Sans.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }
  
  @font-face {
    font-family: 'rather';
    src: url('/fonts/Rather-Regular.woff2') format('woff2'),
    url('/fonts/Rather-Regular.woff') format('woff');
    font-weight: 500;
    font-style: normal;
  }
  
  @font-face {
    font-family: 'rather';
    src: url('/fonts/Rather-Regular.woff2') format('woff2'),
    url('/fonts/Rather-Regular.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }
  
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
  }

 ::selection {
    background: #000;
    color: #ebcf9e;
  }

  ::-moz-selection {
    background: #000;
    color: #ebcf9e;
  }
`;

function Globals({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Meta />
      <Router>
        <ThemeProvider theme={defaultTheme}>
          <StyleBase>{children}</StyleBase>
        </ThemeProvider>
      </Router>
    </>
  );
}

export default Globals;



// WEBPACK FOOTER //
// ./src/Globals.tsx